import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {emit} from '@/utils/events';
import useAuth from '@/hooks/use-auth/use-auth';

import {setFavourite} from '@/redux/actions/productActions';
import {selectProductData} from '@/redux/reducers/productReducer';

import {StyledButton} from '../styles';
import {StyledActiveIcon, StyledIcon} from './styles';
import Props from './typings';
import {pushGAAddToWishlistEvent} from '@/utils/gtm';
import {selectUserSettingsData} from '@/redux/reducers/userSettingsReducer';

const FavouriteButton = ({product}: Props) => {
  const dispatch = useDispatch();
  const auth = useAuth();
  const {favourited} = useSelector(selectProductData);
  const {currency} = useSelector(selectUserSettingsData);
  const [loading, setLoading] = useState(false);

  const onClick = () => {
    if (loading) return;
    if (!auth.isAuthenticated()) {
      emit('CLICK_ON_JOIN');
      return;
    }

    setLoading(true);

    const onSuccessCallbacks = [
      () => {
        pushGAAddToWishlistEvent(product, currency);
      },
    ];

    const onClearCallbacks = [
      () => {
        setLoading(false);
      },
    ];

    dispatch(setFavourite(product.id, onSuccessCallbacks, [], onClearCallbacks));
  };

  return (
    <StyledButton onClick={onClick}>
      {loading || favourited ? (
        <StyledActiveIcon type="heart" fontSize={13} $loading={loading} />
      ) : (
        <StyledIcon type="heart-outlined" fontSize={13} />
      )}

      <u>{favourited ? 'Saved' : 'Save'}</u>
    </StyledButton>
  );
};

export default FavouriteButton;
